import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { isFuture, parse } from "date-fns";
import { locale } from "src/lib/locale/date-fns";
;
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import ExternalImageForUrl from "src/components/images/ExternalImageForUrl";
import Image from 'src/components/images/Image';
import cssPosterStyles from "src/components/posterrow/CSSPoster.module.css";
import { getContentUrl, getContentUrlAzSearch } from 'src/lib/movieinfo/getContentUrl';
import { type ImageVersion, type WatchableContent } from 'src/lib/movieinfo/movieinfotypes';
import { useExperimentalSearchContext } from "src/lib/search/ExperimentalContext";
import { isFilmwebSearchDocument, type ISearchDocument, type ISearchResult } from "src/lib/types/search";
import styles from "./ResultPoster.module.css";

//#region [Props]
type ResultPosterProps = {
  data: WatchableContent;
  forceStreaming?: boolean;
  mobileLayout?: "row" | "column";
  clickTracker?: (id: string | number, title: string) => void;
  className?: string;
};
//#endregion

//#region [Component]
export default function ResultPoster(t0) {
  const $ = _c(49);
  const {
    data,
    className,
    clickTracker,
    mobileLayout: t1,
    forceStreaming: t2
  } = t0;
  const mobileLayout = t1 === undefined ? "column" : t1;
  const forceStreaming = t2 === undefined ? false : t2;
  const hasSanityPoster = !!data.sanityImagePosterUrl;
  const hasStreamingPosterArray = !hasSanityPoster && (data.imagesPosterStreaming?.length ?? 0) > 0 && !data.isCinemaRelevant;
  const hasStreamingPosterUrl = !hasStreamingPosterArray && data.imagePosterStreaming && !data.isCinemaRelevant;
  const hasPoster = hasSanityPoster || hasStreamingPosterArray || hasStreamingPosterUrl;
  let t3;
  if ($[0] !== data || $[1] !== forceStreaming) {
    t3 = getContentUrl(data, forceStreaming);
    $[0] = data;
    $[1] = forceStreaming;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const url = t3;
  const t4 = mobileLayout === "row";
  let t5;
  if ($[3] !== className || $[4] !== t4) {
    t5 = classNames(className, styles.SArticle, cssPosterStyles.CSSPoster, {
      [styles["row-layout"]]: t4
    });
    $[3] = className;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = mobileLayout === "row";
  let t7;
  if ($[6] !== t6) {
    t7 = classNames(styles.SPosterWrapper, cssPosterStyles.CSSPosterWrapper, {
      [styles["row-layout"]]: t6
    });
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = !hasPoster;
  let t9;
  if ($[8] !== t8) {
    t9 = classNames(styles.SImageSizer, cssPosterStyles.CSSPosterSizer, {
      [cssPosterStyles.CSSPosterMissing]: t8
    });
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== clickTracker || $[11] !== data.streamingContentId || $[12] !== data.title) {
    t10 = () => clickTracker?.(data.streamingContentId, data.title);
    $[10] = clickTracker;
    $[11] = data.streamingContentId;
    $[12] = data.title;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== data.imagePosterStreaming || $[15] !== data.imagesPosterStreaming || $[16] !== data.sanityImagePosterUrl || $[17] !== data.title || $[18] !== hasPoster || $[19] !== hasSanityPoster || $[20] !== hasStreamingPosterArray || $[21] !== hasStreamingPosterUrl) {
    t11 = hasPoster && <>{hasSanityPoster && <CmsImageForUrl imageUrl={data.sanityImagePosterUrl} alt={`Poster for '${data.title}'`} unoptimized={true} width={270} />}{hasStreamingPosterArray && <Image alt={`Poster for '${data.title}'`} image={data.imagesPosterStreaming as ImageVersion[]} sizes="270px" />}{hasStreamingPosterUrl && <ExternalImageForUrl imageUrl={data.imagePosterStreaming} alt={`Poster for '${data.title}'`} />}</>;
    $[14] = data.imagePosterStreaming;
    $[15] = data.imagesPosterStreaming;
    $[16] = data.sanityImagePosterUrl;
    $[17] = data.title;
    $[18] = hasPoster;
    $[19] = hasSanityPoster;
    $[20] = hasStreamingPosterArray;
    $[21] = hasStreamingPosterUrl;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== data.title || $[24] !== t10 || $[25] !== t11 || $[26] !== t9 || $[27] !== url) {
    t12 = <FilmwebLink className={t9} to={url} onClick={t10} data-postermissingtext={data.title}>{t11}</FilmwebLink>;
    $[23] = data.title;
    $[24] = t10;
    $[25] = t11;
    $[26] = t9;
    $[27] = url;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t7) {
    t13 = <div className={t7}>{t12}</div>;
    $[29] = t12;
    $[30] = t7;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== clickTracker || $[33] !== data.streamingContentId || $[34] !== data.title) {
    t14 = () => clickTracker?.(data.streamingContentId, data.title);
    $[32] = clickTracker;
    $[33] = data.streamingContentId;
    $[34] = data.title;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== data.title) {
    t15 = <h1>{data.title}</h1>;
    $[36] = data.title;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== data.productionYear) {
    t16 = data.productionYear && data.productionYear !== "0" && data.productionYear !== "-1" && <p>{data.productionYear}</p>;
    $[38] = data.productionYear;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t14 || $[41] !== t15 || $[42] !== t16 || $[43] !== url) {
    t17 = <header className={styles.SPosterHeader}><FilmwebLink onClick={t14} to={url}>{t15}{t16}</FilmwebLink></header>;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
    $[43] = url;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t13 || $[46] !== t17 || $[47] !== t5) {
    t18 = <article className={t5}>{t13}{t17}</article>;
    $[45] = t13;
    $[46] = t17;
    $[47] = t5;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
}
//#endregion

//#region [Props]
type AzResultPosterProps = {
  data: ISearchResult;
  forceStreaming?: boolean;
  mobileLayout?: "row" | "column";
  clickTracker?: (id: string | number, title: string) => void;
  className?: string;
  showScore?: boolean;
  forceHardlinks?: boolean;
};
//#endregion

//#region [Component]
export function AzResultPoster(t0) {
  const $ = _c(57);
  const {
    data,
    className,
    clickTracker,
    mobileLayout: t1,
    forceStreaming: t2,
    showScore: t3,
    forceHardlinks: t4
  } = t0;
  const mobileLayout = t1 === undefined ? "column" : t1;
  const forceStreaming = t2 === undefined ? false : t2;
  const showScore = t3 === undefined ? false : t3;
  const forceHardlinks = t4 === undefined ? false : t4;
  const {
    document
  } = data;
  const hasSanityPoster = !!document.posterUrl;
  let t5;
  if ($[0] !== document) {
    t5 = isFilmwebSearchDocument(document) && !!document.streamingPosterUrl && allowStreamingPoster(document);
    $[0] = document;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const hasStreamingPosterUrl = t5;
  const hasPoster = hasSanityPoster || hasStreamingPosterUrl;
  let t6;
  if ($[2] !== document || $[3] !== forceStreaming) {
    t6 = getContentUrlAzSearch(document, forceStreaming);
    $[2] = document;
    $[3] = forceStreaming;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const url = t6;
  const expContext = useExperimentalSearchContext();
  const t7 = mobileLayout === "row";
  let t8;
  if ($[5] !== className || $[6] !== t7) {
    t8 = classNames(className, styles.SArticle, cssPosterStyles.CSSPoster, {
      [styles["row-layout"]]: t7
    });
    $[5] = className;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== data || $[9] !== expContext) {
    t9 = e => {
      if (e.button === 1) {
        expContext.setOverlayData(data);
      }
    };
    $[8] = data;
    $[9] = expContext;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = mobileLayout === "row";
  let t11;
  if ($[11] !== t10) {
    t11 = classNames(styles.SPosterWrapper, cssPosterStyles.CSSPosterWrapper, {
      [styles["row-layout"]]: t10
    });
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = !hasPoster;
  let t13;
  if ($[13] !== t12) {
    t13 = classNames(styles.SImageSizer, cssPosterStyles.CSSPosterSizer, {
      [cssPosterStyles.CSSPosterMissing]: t12
    });
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== clickTracker || $[16] !== document) {
    t14 = () => clickTracker?.(isFilmwebSearchDocument(document) ? document.streamingId ?? document.edi : document.foMId, document.title);
    $[15] = clickTracker;
    $[16] = document;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== data || $[19] !== showScore) {
    t15 = showScore && <ScoreData searchResult={data} />;
    $[18] = data;
    $[19] = showScore;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== document.posterUrl || $[22] !== document.streamingPosterUrl || $[23] !== document.title || $[24] !== hasPoster || $[25] !== hasSanityPoster || $[26] !== hasStreamingPosterUrl) {
    t16 = hasPoster && <>{hasSanityPoster && <CmsImageForUrl imageUrl={document.posterUrl} alt={`Poster for '${document.title}'`} unoptimized={true} width={270} />}{hasStreamingPosterUrl && !hasSanityPoster && <ExternalImageForUrl imageUrl={document.streamingPosterUrl?.startsWith("/") ? `https://image.tmdb.org/t/p/w780${document.streamingPosterUrl}` : document.streamingPosterUrl} alt={`Poster for '${document.title}'`} />}</>;
    $[21] = document.posterUrl;
    $[22] = document.streamingPosterUrl;
    $[23] = document.title;
    $[24] = hasPoster;
    $[25] = hasSanityPoster;
    $[26] = hasStreamingPosterUrl;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== document.title || $[29] !== forceHardlinks || $[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t16 || $[34] !== url) {
    t17 = <FilmwebLink className={t13} to={url} onClick={t14} data-postermissingtext={document.title} prefetch={false} hardLink={forceHardlinks}>{t15}{t16}</FilmwebLink>;
    $[28] = document.title;
    $[29] = forceHardlinks;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
    $[34] = url;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t11 || $[37] !== t17) {
    t18 = <div className={t11}>{t17}</div>;
    $[36] = t11;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== clickTracker || $[40] !== document) {
    t19 = () => clickTracker?.(isFilmwebSearchDocument(document) ? document.streamingId ?? document.edi : document.foMId, document.title);
    $[39] = clickTracker;
    $[40] = document;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== document.title) {
    t20 = <h2>{document.title}</h2>;
    $[42] = document.title;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== document.yearCinema) {
    t21 = document.yearCinema && document.yearCinema !== "0" && document.yearCinema !== "-1" && <p>{document.yearCinema}</p>;
    $[44] = document.yearCinema;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== forceHardlinks || $[47] !== t19 || $[48] !== t20 || $[49] !== t21 || $[50] !== url) {
    t22 = <header className={styles.SPosterHeader}><FilmwebLink prefetch={false} onClick={t19} to={url} hardLink={forceHardlinks}>{t20}{t21}</FilmwebLink></header>;
    $[46] = forceHardlinks;
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
    $[50] = url;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t18 || $[53] !== t22 || $[54] !== t8 || $[55] !== t9) {
    t23 = <article className={t8} onMouseDown={t9}>{t18}{t22}</article>;
    $[52] = t18;
    $[53] = t22;
    $[54] = t8;
    $[55] = t9;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  return t23;
}
//#endregion

function ScoreData(t0) {
  const $ = _c(15);
  const {
    searchResult
  } = t0;
  let t1;
  if ($[0] !== searchResult.score) {
    t1 = <div>sc: {searchResult.score}</div>;
    $[0] = searchResult.score;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== searchResult.document) {
    t2 = isFilmwebSearchDocument(searchResult.document) && searchResult.document.popularity?.toFixed(3);
    $[2] = searchResult.document;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div>pop: {t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = searchResult.rawScore ?? searchResult.score;
  let t5;
  if ($[6] !== t4) {
    t5 = <div>rawsc: {t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== searchResult.document.isFullResult) {
    t6 = searchResult.document.isFullResult && <div>Fullt søk</div>;
    $[8] = searchResult.document.isFullResult;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t5 || $[13] !== t6) {
    t7 = <div className={styles.SScoreData}>{t1}{t3}{t5}{t6}</div>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function allowStreamingPoster(document: ISearchDocument): boolean {
  if ((document.numShows ?? 0) > 0) return false;
  if (document.movieCinemaPremiere) {
    try {
      const premiere = parse(document.movieCinemaPremiere, "yyyy-MM-dd'T'HH:mm:ssXXX", new Date(), {
        locale
      });
      if (isFuture(premiere)) return false;
    } catch (e) {
      console.error("Error parsing premiere date", e, document.movieCinemaPremiere);
    }
  }
  return true;
}